export default function() {
  const garagePage = $('#garageBlock');
  const garageEditPage = $('.page-add-edit-bike');
  const retriesCount = 5;

  if (garagePage.length || $('#new-add-bike-link').length) {
    checkBikesGaragePage();
  }

  if (garageEditPage.length) {
    checkBikeModelSelect();
  }

  $('#trekBikeForm').on('submit', function(e) {
    const addBikeUrl = `${ACC.config.encodedContextPath}/my-account/add-bike`;
    const getBikesUrl = `${ACC.config.encodedContextPath}/customer/profile/garage/`;
    const addNewBike = true;
    const submitButton = $('#editBikeSubmitBtn');
    const countRequests = 0;
    const dataString = $(this).serialize();
    const currentBikeName = $('input[name=bikeName]').val();
    let currentData = 0;

    if (currentBikeName.trim()) {
      e.preventDefault();

      $.getJSON(getBikesUrl).done(function(data) {
        if (data.data) {
          currentData = data.data.length;
          submitBikesForm(addBikeUrl, getBikesUrl, addNewBike, submitButton, countRequests, dataString, currentData);
        } else {
          submitBikesForm(addBikeUrl, getBikesUrl, addNewBike, submitButton, countRequests, dataString, currentData);
        }
      });
    }
  });

  $('#trekBikeFormEdit').on('submit', function(e) {
    const currentData = $('#currentBikeId').val();
    const addBikeUrl =  `${ACC.config.encodedContextPath}/my-account/edit-bike/${currentData}`;
    const getBikesUrl = `${ACC.config.encodedContextPath}/customer/profile/garage/`;
    const addNewBike = false;
    const submitButton = $('#editBikeSubmitBtn');
    const countRequests = 0;
    const dataString = $(this).serialize();
    const currentBikeName = $('input[name=bikeName]').val();

    if (currentBikeName.trim()) {
      e.preventDefault();
      submitBikesForm(
        addBikeUrl,
        getBikesUrl,
        addNewBike,
        submitButton,
        countRequests,
        dataString,
        currentData,
        currentBikeName
      );
    }
  });

  function submitBikesForm(
    addBikeUrl,
    getBikesUrl,
    addNewBike,
    submitButton,
    countRequests,
    dataString,
    currentData,
    currentBikeName
  ) {
    const redirectToGarageUrl = `${ACC.config.encodedContextPath}/my-account/garage/`;
    submitButton.prop('disabled', true);

    $.ajax({
      type: 'POST',
      url: addBikeUrl,
      data: dataString,
      success: function() {
        if (addNewBike) {
          checkBikesInGigya(countRequests, currentData, getBikesUrl);
        } else {
          checkCurrentBikeInGigya(countRequests, currentData, currentBikeName, getBikesUrl);
        }
      },
      error: function() {
        submitButton.prop('disabled', false);
        window.location.href = redirectToGarageUrl;
      },
    });
  }

  function checkBikesInGigya(countRequests, garageBikes, getBikesUrl) {
    const redirectToGarageUrl = `${ACC.config.encodedContextPath}/my-account/garage/`;
    let updatedGarageBikes = 0;

    countRequests++;

    $.getJSON(getBikesUrl, function(data) {
      if (data.data) {
        updatedGarageBikes = data.data.length;
      }
      if (countRequests >= retriesCount) {
        sessionStorage.setItem('bikesUpdated', false);
        sessionStorage.setItem('oldGarageBikesQty', garageBikes);
        window.location.href = redirectToGarageUrl;
      } else if (countRequests < retriesCount && garageBikes + 1 === updatedGarageBikes) {
        sessionStorage.setItem('bikesUpdated', true);
        sessionStorage.setItem('oldGarageBikesQty', garageBikes);
        window.location.href = redirectToGarageUrl;
      } else {
        setTimeout(() => checkBikesInGigya(countRequests, garageBikes, getBikesUrl), 2000);
      }
    });
  }

  function checkCurrentBikeInGigya(countRequests, currentData, currentBikeName, getBikesUrl) {
    const redirectToGarageUrl = `${ACC.config.encodedContextPath}/my-account/garage/`;
    let updatedGarageBikes = [];

    countRequests++;

    $.getJSON(getBikesUrl, function(data) {
      if (data.data) {
        updatedGarageBikes = data.data;
      }
      if (updatedGarageBikes[currentData - 1].customerBikeName === currentBikeName) {
        sessionStorage.setItem('bikesUpdated', true);
        window.location.href = redirectToGarageUrl;
      } else if (countRequests >= retriesCount) {
        sessionStorage.setItem('bikesUpdated', false);
        sessionStorage.setItem('bikeId', currentData);
        sessionStorage.setItem('currentBikeName', currentBikeName);
        window.location.href = redirectToGarageUrl;
      } else {
        setTimeout(() => checkCurrentBikeInGigya(countRequests, currentData, currentBikeName, getBikesUrl), 2000);
      }
    });
  }

  function checkBikesGaragePage() {
    const errorMessageContainer = $('#garageUpdateError');
    const addBikeSuccessMessage = $('#addBikeSuccessMessage');
    const bikeNamesList = [];
    const garageData = $('[data-name]');
    const currentGarageBikes = $('#garageBlock').data('bikes');
    const oldGarageBikesQty = sessionStorage.getItem('oldGarageBikesQty');
    const bikesUpdated = sessionStorage.getItem('bikesUpdated');
    const currentBikeName = sessionStorage.getItem('currentBikeName');
    const bikeId = sessionStorage.getItem('bikeId');

    for (let bikeName of garageData) {
      bikeNamesList.push($(bikeName).data('name'));
    }

    if (currentGarageBikes == parseInt(oldGarageBikesQty) + 1) {
      errorMessageContainer.addClass('hide');
      addBikeSuccessMessage.removeClass('hide');
      sessionStorage.removeItem('oldGarageBikesQty');
      sessionStorage.removeItem('bikesUpdated');
    } else if (garageData && bikeId && currentBikeName && bikeNamesList[bikeId - 1] === currentBikeName) {
      errorMessageContainer.addClass('hide');
      sessionStorage.removeItem('bikeId');
      sessionStorage.removeItem('currentBikeName');
      sessionStorage.removeItem('bikesUpdated');
    } else if (bikesUpdated === 'false') {
      errorMessageContainer.removeClass('hide');
      sessionStorage.removeItem('oldGarageBikesQty');
      sessionStorage.removeItem('bikesUpdated');
    } else {
      errorMessageContainer.addClass('hide');
    }
  }

  function checkBikeModelSelect() {
    var bikeCategory = $('#category')
      .find(':selected')
      .val();
    if ($('#models option').length > 1 && bikeCategory) {
      $('#models').removeAttr('disabled');
    }
  }
}
